import React, { useCallback, useEffect, useRef, useState } from "react";
import { Nav, NavItem, NavLink } from 'reactstrap'
import PatientContent from "./PatientContent";
import PatientMenu from "./PatientMenu";
import { useDispatch, useSelector } from "react-redux";
// import NotesTab from "../../General/NotesTab/NotesTab";
import PatientNotesTab from "../../General/NotesTab/PatientNotesTab";
import { OpenNewPatientTabAction } from "../../../actions/PatientActions";
import ContentReceiver from "../../MenuLayout/ContentReceiverNewBrowserTab/ContentReceiver";
import AddAlert from "../../General/AddAlert";
import ActiveAlert from "../../General/ActiveAlert";
import isNull from "../../../utils/NullChecking";
import AddNewTask from "../../Home/TaskManagement/AddNewTask";
import AddNewAppointment from "../../Scheduler/AddNewAppointment";
import CustomUseRef from "../../shared/DropDown/CustomUseRef";
import MergePatient from "../PatientOptions/MergePatient/MergePatient";
import DeleteConfirmatiom from "../../General/DeleteConfirmation";
import { enumUtil } from "../../../utils/Enum";
import AddNewTicket from "../../Support/AddNewTicket";
import { GeneralDropDowns } from "../../../actions/GeneralPatientActions";
import { ServerRequestProtected } from "../../../utils/ServerDataRequest";
import { debounce } from "lodash";
import { Menu } from "@mui/material";
import { FindFirstChild } from "../../../utils/FindMenuOption";

const PatientTopMenu = (props) => {
    let PatientID = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    let PatientName = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.name;
    let isPateintSubTapOpen = false
    let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.id;
    let PatientTab = useSelector(state => state.Open_Patient_Tab);
    const [patientIDR, setPatientIDR] = useState("");

    let EncounterTab = useSelector(state => state.Open_Patient_Tab)?.find(pat => pat.data.id === patientIDR)?.Open_Encounter_Tab;
    let isDeleteAllowed = FindFirstChild('Patient', 'Patients')?.IsDeleted
    // let reduxData = useSelector(state => state.Open_Claim_Tab);

    const API_URL = enumUtil.controller.General
    let PatientActiveSub = PatientTab[PatientTab.length - 1]?.data?.type;
    const [PatientActiveSubTab, setPatientActiveSubTab] = useState(PatientActiveSub);
    let isNewPtSaved = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true));
    let dispatch = useDispatch();
    let PatientData = useSelector(state => state.PatientRecordReducer);
    let FirstPatient;
    let LastPateint;
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    const isHomeCareCheck = DropDowns.IsHomeCare
    const isAdultCareCheck = DropDowns.IsAdultDayCare
    if (PatientData.length > 0) {
        FirstPatient = PatientData[0]
        LastPateint = PatientData[PatientData.length - 1]
    }
    if (isNewPtSaved && isNewPtSaved.data) {
        isNewPtSaved = isNewPtSaved.data.newPatient;
    }
    if (PatientID && PatientID.data) {
        isPateintSubTapOpen = PatientID.data.isPateintSubTapOpen;
        PatientID = PatientID.data.id;
    }
    // if (PatientName && PatientName.data) {
    //     PatientName = PatientName.data.name;
    // }
    const MenuItems = PatientMenu();
    const [subCategItems, setSubCategItems] = useState([])
    const [tabList, setTabsList] = useState([])
    const [activeTab, setActiveTab] = useState()
    const [subMenuActive, setSubMenuActive] = useState(false);
    const [openTab, setOpenTab] = useState('')
    const [isOpenAlertType, setisOpenCategoryType] = useState(false)
    const [isAlertVisible, setAlertVisible] = useState(false);
    const [TaskID, SetTaskID] = useState()
    const [Isopen, setIsopen] = useState(false);
    const [isClose, setIsClose] = useState();
    const [patientModal, setPatientModal] = useState(false);
    const [appointmentID, setAppointmentID] = useState("")
    const [mergeEvent, setMergeEvent] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [IsActivePtPayments, setIsActivePtPayments] = useState(false)
    const [isSupportOpen, setSupportPopup] = useState(false);
    const [SupportTicketID, setSupportTicketID] = useState(null);
    useEffect(() => {
        setPatientIDR(PatientIDR)
    }, [])
    useEffect(() => {
        setPatientActiveSubTab(PatientTab[0]?.data?.type);
    }, [PatientTab])
    const getSupportTicket = (ID) => {
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.SupportTicket,
            "SearchCriteria": {
                "Peram": "Patient",
                "PatientID": ID,
            }
        }
        ServerRequestProtected(API_URL + '/DropDown', 'post', saveModal)
            .then((response) => {
                let ticketID = response?.[0]?.SupportTicketID;
                setSupportTicketID(ticketID);
            }).catch((error) => {
                setSupportTicketID(null);
            })
    }
    useEffect(() => {
        if (!isNull(PatientID)) {
            getSupportTicket(PatientID);
        }
    }, [PatientID])
    useEffect(() => {
        if (EncounterTab && EncounterTab.length > 0) {
            let item = subCategItems.find(item => item.name === "Encounter");
            if (!item) return
            handleActiveTab(item);
        }
    }, [EncounterTab])
    // useEffect(() => {
    //     const handleOutsideClick = (event) => {
    //         const menuButton = document.querySelector(".btn-icon-transparent.dots-menu");
    //         const submenu = document.querySelector(".claims-TabHeader__right__submenu");

    //         if (submenu && !submenu.contains(event.target) && menuButton && !menuButton.contains(event.target)) {
    //             setSubMenuActive(false);
    //         }
    //     };

    //     if (subMenuActive) {
    //         document.addEventListener("click", handleOutsideClick);
    //     }

    //     return () => {
    //         document.removeEventListener("click", handleOutsideClick);
    //     };
    // }, [subMenuActive]);
    useEffect(() => {
        const selected_Item_List = MenuItems.filter((item) => item.key === props.subCategKey);
        if (selected_Item_List && selected_Item_List.length > 0) {
            let subCategories = selected_Item_List[0].subCategoryItems
            let subCatItems = subCategories.filter((item) => item.right === true)
            let DemographicsTab = subCatItems.filter((item) => item.key === 212)
            let InsuranceTab = subCatItems.filter((item) => item.key === 213)
            let EncounterTAB = subCatItems.filter((item) => item.key === 218)
            if (PatientID != -1) {
                if (isNewPtSaved === true) {
                    setSubCategItems(subCategories)
                    if (DemographicsTab.length > 0) {
                        setActiveTab(DemographicsTab[0]?.key)
                        handleActiveTab(DemographicsTab[0])
                    } else {
                        setActiveTab(subCatItems[0]?.key)
                        handleActiveTab(subCatItems[0])
                    }
                } else {
                    setSubCategItems(subCategories)
                    if (PatientActiveSubTab) {
                        if (PatientActiveSubTab === "Demographics") {
                            if (DemographicsTab.length > 0) {
                                setActiveTab(DemographicsTab[0]?.key)
                                setTabsList([DemographicsTab[0]])
                                dispatch(GeneralDropDowns({
                                    ...DropDowns, DisCardActiveIds: {
                                        ...GenDD?.DisCardActiveIds,
                                        Patient: [...GenDD?.DisCardActiveIds.Patient, {
                                            isDemographicsOpened: true,
                                            isDemographicsUpdated: false,
                                            isInsuranceOpened: false,
                                            isInsuranceUpdated: false,
                                            PatientID: PatientID,
                                        }]
                                    }
                                }))
                            } else {
                                setActiveTab(subCatItems[0]?.key)
                            }
                            // setActiveTab(subCategories[1].key)
                            // setTabsList([subCategories[1]])
                        }
                        else if (PatientActiveSubTab === "Insurances") {
                            if (InsuranceTab.length > 0) {
                                setActiveTab(InsuranceTab[0]?.key)
                                setTabsList([InsuranceTab[0]])
                                dispatch(GeneralDropDowns({
                                    ...DropDowns, DisCardActiveIds: {
                                        ...GenDD?.DisCardActiveIds,
                                        Patient: [...GenDD?.DisCardActiveIds.Patient, {
                                            isDemographicsOpened: false,
                                            isDemographicsUpdated: false,
                                            isInsuranceOpened: true,
                                            isInsuranceUpdated: false,
                                            PatientID: PatientID,
                                        }]
                                    }
                                }))
                            } else {
                                setActiveTab(subCatItems[0]?.key)
                            }
                            // setActiveTab(subCategories[2].key)
                            // setTabsList([subCategories[2]])
                        }
                        else if (PatientActiveSubTab === "Encounter") {
                            if (EncounterTAB.length > 0) {
                                setActiveTab(EncounterTAB[0]?.key)
                                setTabsList([EncounterTAB[0]])
                                dispatch(GeneralDropDowns({
                                    ...DropDowns, DisCardActiveIds: {
                                        ...GenDD?.DisCardActiveIds,
                                        Patient: [...GenDD?.DisCardActiveIds.Patient, {
                                            isDemographicsOpened: false,
                                            isDemographicsUpdated: false,
                                            isInsuranceOpened: false,
                                            isInsuranceUpdated: false,
                                            PatientID: PatientID,
                                        }]
                                    }
                                }))
                            } else {
                                setActiveTab(subCatItems[0]?.key)
                            }
                        }
                        else {
                            setActiveTab(subCatItems[0]?.key)
                        }
                    }
                    else {
                        setActiveTab(subCatItems[0]?.key)
                    }
                }
            } else {

                let NewPatient = subCategories.filter((item) => {
                    if (item.key === 212) {
                        return item
                    }
                })

                setSubCategItems(NewPatient)
                setActiveTab(NewPatient[0]?.key)
            }
            setAlertVisible(true);
        }
    }, [props.subCategKey])
    const handleCreateAlert = () => {
        setisOpenCategoryType(true);
    };
    const handleActiveTab = (item) => {
        if (item.key === 212) {
            let DD = DropDowns
            DD?.DisCardActiveIds?.Patient.map((item) => {
                if (item.PatientID + "" === PatientID + "") {
                    item.isDemographicsOpened = true
                }
            })
            dispatch(GeneralDropDowns(DD))
        } else if (item.key === 213) {
            let DD = DropDowns
            DD?.DisCardActiveIds?.Patient.map((item) => {
                if (item.PatientID + "" === PatientID + "") {
                    item.isInsuranceOpened = true
                }
            })
            dispatch(GeneralDropDowns(DD))
        }
        let reduxGeneralDD = DropDowns
        reduxGeneralDD['PatientSubActiveTab'] = item.key
        dispatch(GeneralDropDowns(reduxGeneralDD))
        if (!item?.right) {
            return
        } else {
            const { key, name, right, component } = { ...item }
            let dynamicTabs = [...tabList]
            if (tabList.length === 0) {
                const activeTabElement = subCategItems.filter((item) => item.key === activeTab)
                const obj = {
                    key: activeTabElement.key,
                    name: activeTabElement.name,
                    right: activeTabElement.right,
                    component: activeTabElement.component,
                }
                dynamicTabs.push(obj)
            }
            const newTabObject = {
                key: key,
                name: name,
                right: right,
                component: component,
            }
            const isTabExist = dynamicTabs.filter((tab) => {
                return tab.name === name
            })
            if (!(isTabExist && isTabExist.length > 0)) {
                dynamicTabs = [...dynamicTabs, newTabObject]
                setTabsList(dynamicTabs)
            }
            if (activeTab !== key) {
                setActiveTab(key)
            }
        }
    }
    const handleNext = () => {
        let nextPatientid;
        let nextPatientName;
        for (let i = 0; i < PatientData.length; i++) {
            let item = PatientData[i]
            if (item.ID === PatientID) {
                nextPatientid = PatientData[i + 1]['ID']
                nextPatientName = PatientData[i + 1]['name']
            }
        }
        let obj = {
            key: 2,
            name: "Patient",
            active: true,
            data: {
                id: nextPatientid + "",
                name: nextPatientName,
                time: new Date(),
            },
        };
        let updatedData = PatientTab.filter((item) => item.data.id !== nextPatientid)
            .map((item) => {
                if (item.data.id === PatientID) {
                    return obj;
                }
                return item;
            });
        if (!isNull(nextPatientid)) {
            dispatch(GeneralDropDowns({
                ...GenDD, DisCardActiveIds: {
                    ...GenDD?.DisCardActiveIds,
                    Patient: [...GenDD?.DisCardActiveIds.Patient, {
                        isDemographicsOpened: false,
                        isDemographicsUpdated: false,
                        isInsuranceOpened: false,
                        isInsuranceUpdated: false,
                        PatientID: nextPatientid,
                    }]
                }
            }))
        }

        dispatch(OpenNewPatientTabAction(updatedData))
    }
    const handleBack = () => {
        let nextPatientid;
        let nextPatientName;
        for (let i = 0; i < PatientData.length; i++) {
            let item = PatientData[i]
            if (item.ID === PatientID) {
                nextPatientid = PatientData[i - 1]['ID']
                nextPatientName = PatientData[i - 1]['name']
            }
        }

        let obj = {
            key: 2,
            name: "Patient",
            active: true,
            data: {
                id: nextPatientid + "",
                name: nextPatientName,
                time: new Date(),
            },
        };
        let updatedData = PatientTab.filter((item) => item.data.id !== nextPatientid)
            .map((item) => {
                if (item.data.id === PatientID) {
                    return obj;
                }
                return item;
            });
        if (!isNull(nextPatientid)) {
            dispatch(GeneralDropDowns({
                ...GenDD, DisCardActiveIds: {
                    ...GenDD?.DisCardActiveIds,
                    Patient: [...GenDD?.DisCardActiveIds.Patient, {
                        isDemographicsOpened: false,
                        isDemographicsUpdated: false,
                        isInsuranceOpened: false,
                        isInsuranceUpdated: false,
                        PatientID: nextPatientid,
                    }]
                }
            }))
        }
        dispatch(OpenNewPatientTabAction(updatedData))
    }
    let ets = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true))?.data?.name;
    const handleViewAllClaim = () => {
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "All Claims",
                id: 0,
                time: new Date(),
                visitType: {
                    type: 'ClaimSearch',
                    PatientID: PatientID,
                    PatientName: ets,
                },
            },
        };
        setOpenTab(dataObj)
    }
    const CreateProfessionalClaim = () => {
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "New Professional",
                id: -1,
                time: new Date(),
                visitType: "P",
            },
        };
        setOpenTab(dataObj)
    }
    const CreateAgencyClaim = () => {
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "New Claim",
                id: -1,
                time: new Date(),
                visitType: "P",
            },
        };
        setOpenTab(dataObj)
    }
    let Alert = ""
    if (isAlertVisible && !isNull(PatientID)) {
        Alert = <ActiveAlert alertFrom={'Patient'} ID={PatientID} display={`Patient ${PatientName}`} CallingFrom='Patient' />
    }
    const CreateInstitutionalClaim = () => {
        let dataObj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                name: "New Institutional",
                id: -2,
                time: new Date(),
                visitType: "I"
            },
        };
        setOpenTab(dataObj)
    }
    const handleCreateTask = () => {
        SetTaskID('0');
        setIsopen(true);
    }
    const [reload, setReload] = useState(false)
    const handleReloadPatient = () => {
        setReload(!reload)
    }
    const DeleteTask = () => {
        setIsopen(false)
        setIsClose((Math.random()));
    }
    const open = () => {
        setIsopen(true)
    }
    const close = () => {
        setIsopen(false)
    }
    let popupScreen = ""
    if (Isopen) {
        popupScreen = <AddNewTask IsOpen={open} IsClosed={close} onDeleteTask={DeleteTask} Task={TaskID} selectedPatientID={FirstPatient} PatientName={'Patient'} />
    }
    const handleCreateAppointment = (PatientID) => {
        setAppointmentID('0')
        setShowEvents(true);
    }
    const handleOnClose = () => {
        setShowEvents(false);
    }
    const handleOnCloseSave = () => {
        handleReloadPatient()
        setShowEvents(false);
    }
    let popUp = "";
    if (showEvents) {
        popUp = <AddNewAppointment AppointmentID={appointmentID} showEvents={showEvents} handleOnClose={handleOnClose} handleOnCloseSave={handleOnCloseSave} PatientID={PatientID} openedFrom={'Patient'} />;
    }
    // const handleOpenTask = () => {
    //     setisOpenTask(true)
    //   }
    //   const onCloseChangeTask = () => {
    //     setisOpenTask(false)
    //   }
    //   const DeleteTask = () => {
    //     setisOpenTask(false)
    //     // setIsClose((Math.random()));
    // }
    // let TaskPopup = '';
    // if (isOpenTask) {
    //   TaskPopup = <AddNewTask IsOpen={isOpenTask} IsClosed={onCloseChangeTask} onDeleteTask={DeleteTask} selectedPateintID={FirstPatient} PateintName ={'Pateint'} />
    // }
    ////////////////////////// 
    const handleMergePatient = (patientID) => {
        setMergeEvent(true);
    }
    const handleMergeClose = () => {
        setMergeEvent(false);
    }
    let MergePopup = '';
    if (mergeEvent) {
        MergePopup = <MergePatient mergeEvent={mergeEvent} onClose={handleMergeClose} />
    }
    //////////////////////////
    const closeDropdown = () => {
        setSubMenuActive(false)

    };
    const handleSubMenu = (e) => {
        setSubMenuActive(!subMenuActive)
        e.stopPropagation();

    }
    // const handleDeleteModal = () => {
    //     setisOpenAlert(true)
    // }
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [paitentID, setPatientID] = useState("")
    const handleOpen = (id) => {
        if (isDeleteAllowed) {
            setisOpenAlert(true)
            setPatientID(id)
        }
    }
    let id = PatientTab.filter(item => item.data.id + "" !== paitentID + "")
    const CloseDelete = () => {

        let ReduxUpdatedData = PatientTab.filter(item => item.data.id + "" !== paitentID + "")
        let lengthUpdatedData = ReduxUpdatedData.length
        ReduxUpdatedData.map((item, index) => {
            if (index === lengthUpdatedData - 1) {
                item.active = true
            }
        })
        dispatch(OpenNewPatientTabAction(ReduxUpdatedData))
        setisOpenAlert(false)

    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} onClose={CloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.Patient} ID={paitentID} />
    }
    const handleGetSupport = (e) => {
        setSupportPopup(true);
        e.stopPropagation();
    }
    const onCloseGetSupport = () => {
        setSupportPopup(false);
    }
    const onCloseGetSupportSave = () => {
        setSupportPopup(false);
        getSupportTicket(PatientID);
    }
    let SupportPopup = "";
    if (isSupportOpen) {
        SupportPopup = <AddNewTicket IsOpen={isSupportOpen} IsClosed={onCloseGetSupport} onDeleteTask={onCloseGetSupportSave} selectedIDs={{ value: PatientID, display: PatientName }} type={'Patient'} Ticket={SupportTicketID} />
    }
    //shortcut keys
    let GenDD = useSelector(state => state.GeneralDropDownsReducer);
    let SideBarActiveKey = useSelector(state => state.SidebarActiveTab);

    const comboKeys = useRef([]); // ✅ Holds current key sequence
    const isInputFocused = () => {
        const activeElement = document.activeElement;
        return (
            activeElement.tagName === 'INPUT' ||
            activeElement.tagName === 'TEXTAREA' ||
            activeElement.tagName === 'SELECT' ||
            activeElement.isContentEditable
        );
    };
    const executeCombo = useCallback(
        debounce(() => {
            if (isInputFocused()) {
                comboKeys.current = []; // Clear combo if input is focused
                return;
            }
            const sequence = comboKeys.current.join('+');
            if (SideBarActiveKey === 2) {
                if (sequence === 'n+r') {
                    handleNext();
                } else if (sequence === 'p+r') {
                    handleBack();
                } else if (sequence === 'n+t') {
                    let nextTab = MenuItems[0]?.subCategoryItems?.findIndex(item => item.key === activeTab) + 1
                    handleActiveTab(MenuItems[0]?.subCategoryItems[nextTab]);
                } else if (sequence === 'p+t') {
                    let nextTab = MenuItems[0]?.subCategoryItems?.findIndex(item => item.key === activeTab) - 1
                    handleActiveTab(MenuItems[0]?.subCategoryItems[nextTab]);
                } else if (sequence === 'r+r') {
                    handleReloadPatient();
                }
            } else {

            }
            comboKeys.current = []; // ✅ Clear combo after handling

        }, 500), [GenDD, SideBarActiveKey, activeTab])
    useEffect(() => {
        const handleKeyDown = (event) => {
            // if (!event.altKey) return;
            if (isInputFocused()) {
                return;
            }
            const key = event.key.toLowerCase();

            // if (['n', 'r', 'p', 'escape'].includes(key)) {
            //     event.preventDefault();
            //     event.stopPropagation();
            // }
            comboKeys.current.push(key);
            executeCombo(); // Debounced logic
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            executeCombo.cancel(); // ✅ Clean up debounce
        };
    }, [executeCombo]);

    return (
        <div className='app-tabs claims-TabHeader border-0'>
            {Alert}
            {popupScreen}
            {popUp}
            {MergePopup}
            {DeleteConfirmation}
            {SupportPopup}
            <div className="d-flex justify-content-between br-clr br-bottom-1">
                <Nav className="rb-tabs-v3 ar_pateint-tab">
                    {subCategItems && subCategItems.map((item) => {
                        return (
                            <React.Fragment key={item.key}>
                                <NavItem onClick={() => handleActiveTab(item)}>
                                    <NavLink href="#"
                                        // className={activeTab === item.key ? "py-2 active" : "py-2"}
                                        className={`${activeTab === item.key ? "py-2 active" : "py-2"} ${item.right === false ? 'sidebar-disableed' : ''}`} disabled={item.right}
                                    >
                                        <i className={item.icon} /> {item.name}
                                    </NavLink>
                                </NavItem>
                            </React.Fragment>
                        );
                    })}
                </Nav>
                {isPateintSubTapOpen !== true ?
                    <>
                        {PatientID && PatientID !== -1 ?
                            <>
                                <div className="d-flex align-items-center gap-1">
                                    <button className='btn btn-gethelp no-width rounded px-2 d-flex align-items-center gap-1 text-nowrap' onClick={(e) => handleGetSupport(e)}> <i className="icon-Vector15 fs-12"></i> {!isNull(SupportTicketID) ? 'View Ticket' : 'Get Help'}</button>
                                    <div className="claims-TabHeader__right">
                                        <span class="icon-Reloading-icon1 fs-19" onClick={handleReloadPatient}><span class="path1"></span><span class="path2"></span></span>
                                        <button className={FirstPatient && PatientID === FirstPatient.ID ? "btn disable" : "btn"} onClick={handleBack}>
                                            <i className="icon-Icon-ionic-md-arrow-round-back"></i>
                                        </button>
                                        <button className={LastPateint && PatientID === LastPateint.ID ? "btn disable" : "btn"} onClick={handleNext}>
                                            <i className="icon-arrow-right"></i>
                                        </button>
                                        <button
                                            className="btn-icon-transparent dots-menu"
                                            onClick={handleSubMenu}
                                        >
                                            <i className="icon-dots-menu"></i>
                                        </button>
                                        {<CustomUseRef onClose={closeDropdown} IsActivePtPayments={subMenuActive}>
                                            {
                                                <div className={`claims-TabHeader__right__submenu ${subMenuActive && "active"}`}>
                                                    {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}
                                                    <div className="itemList">
                                                        <div className="itemList__item" onClick={handleViewAllClaim}>
                                                            View All Claims
                                                            <button
                                                                className="btn-icon-transparent"
                                                                onClick={() => setSubMenuActive(!subMenuActive)}
                                                            >
                                                                {/* <i className="icon-Icon-metro-cross"></i> */}
                                                            </button>
                                                        </div>
                                                        {isHomeCareCheck === 'true' ? <div className="itemList__item" onClick={CreateAgencyClaim}>Create Claim</div>
                                                            :
                                                            <React.Fragment>
                                                                <div className="itemList__item" onClick={CreateProfessionalClaim}>Create Professional Claim</div>
                                                                <div className="itemList__item" onClick={CreateInstitutionalClaim}>Create Institutional Claim</div>
                                                            </React.Fragment>
                                                        }
                                                        <div className="itemList__item" onClick={() => handleCreateTask()}>Create Task</div>
                                                        <div className="itemList__item">Post Payment</div>
                                                        <div className="itemList__item" onClick={handleCreateAlert}>Create Alert</div>
                                                        {(isHomeCareCheck === 'false' && isAdultCareCheck === 'false') ? <div className="itemList__item" onClick={() => handleCreateAppointment(PatientID)}>Create Appointment</div> : null}
                                                        <div className="itemList__item" onClick={() => handleMergePatient(PatientID)}>Merge Patient</div>
                                                        <div className={isDeleteAllowed ? "itemList__item" : "itemList__item disabled"} onClick={() => handleOpen(PatientID)}>Delete Patient</div>

                                                    </div>
                                                </div>}
                                        </CustomUseRef>}

                                    </div>
                                </div>
                            </>

                            : ''}
                    </>
                    :
                    <>
                        <div className="claims-TabHeader__right">
                            <button
                                className="btn-icon-transparent dots-menu"
                                onClick={handleSubMenu}
                            >
                                <i className="icon-dots-menu"></i>
                            </button>
                        </div>
                        {<CustomUseRef onClose={closeDropdown} IsActivePtPayments={subMenuActive}>
                            {
                                <div className={`claims-TabHeader__right__submenu ${subMenuActive && "active"}`}>
                                    {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab} /> : null}
                                    <div className="itemList">
                                        <div className="itemList__item" onClick={handleViewAllClaim}>
                                            View All Claims
                                            <button
                                                className="btn-icon-transparent"
                                                onClick={() => setSubMenuActive(!subMenuActive)}
                                            >
                                                {/* <i className="icon-Icon-metro-cross"></i> */}
                                            </button>
                                        </div>
                                        {isHomeCareCheck === 'true' ? <div className="itemList__item" onClick={CreateAgencyClaim}>Create Claim</div>
                                            :
                                            <React.Fragment>
                                                <div className="itemList__item" onClick={CreateProfessionalClaim}>Create Professional Claim</div>
                                                <div className="itemList__item" onClick={CreateInstitutionalClaim}>Create Institutional Claim</div>
                                            </React.Fragment>
                                        }
                                        <div className="itemList__item" onClick={() => handleCreateTask()}>Create Task</div>
                                        <div className="itemList__item">Post Payment</div>
                                        <div className="itemList__item" onClick={handleCreateAlert}>Create Alert</div>
                                        <div className="itemList__item" onClick={() => handleCreateAppointment(PatientID)}>Create Appointment</div>
                                        <div className="itemList__item" onClick={() => handleMergePatient(PatientID)}>Merge Patient</div>
                                    </div>
                                </div>}
                        </CustomUseRef>}
                    </>


                }
                {/* <NotesTab name={'Patient'} /> */}
                {PatientID && PatientID !== -1 ? <PatientNotesTab /> : null}
            </div>
            <PatientContent activeTab={activeTab} dynamicTabs={tabList} subCategItems={subCategItems} Reload={reload} ActivePatientID={PatientID} />
            <AddAlert isOpenAlertType={isOpenAlertType} onClose={() => setisOpenCategoryType(false)} loadAlertData={null} type={'PatientID'} Name={'Patient'} />
        </div>
    );
}

export default PatientTopMenu